import React, { useEffect, useState } from "react";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { SearchSelectWithEnum } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { getBooleanDisplayIcon } from "../../../../helpers/utils/Utils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useSearchTaxRoundingConfigQuery } from "../taxRoundingConfigApi";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";


const TaxRoundingConfig = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Tax Rounding Configs", url: "" }]
    )

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Tax Rounding Config");

    const { data: enums } = useGetEnumsQuery("");
    const navigate = useNavigate()
    useEffect(() => {

        document.title = 'Tax Rounding Configs';

    }, []);


    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name",
            cell: (props: any) => {
                let path = "/tax-rounding-config/" + props.row.original.id;
                return createClickableLink(path, props.value, userSetting, false, "", ["TAXRCONF-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"test"} placeholder={"Enter Name..."}
                    accessor={"name"} />,
                overrideFilterAccessor: "name"
            }]
        },
        {
            label: "Round Base",
            accessor: "roundBase",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Base...", false, "roundBase"),
            }]
        },
        {
            label: "Round Penalty",
            accessor: "roundPenalty",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Penalty...", false, "roundPenalty"),
            }]
        },
        {
            label: "Round Interest",
            accessor: "roundInterest",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Interest...", false, "roundInterest"),
            }]
        },
        {
            label: "Round Subtotal",
            accessor: "roundSubtotal",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Subtotal...", false, "roundSubtotal"),
            }]
        },
        {
            label: "Round Attorney Fee",
            accessor: "roundAttorneyFee",
            cell: (props: any) => {
                return <>
                    <span>
                        {getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Attorney Fee...", false, "roundAttorneyFee"),
            }]
        },

        {
            label: "Round Total",
            accessor: "roundFinalResult",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["RoundingType"], props.value)}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["RoundingType"], "Select Round Total...", false, "roundFinalResult"),
            }]
        },

        {
            label: "Integer Arithmetic", accessor: "useIntegerArithmetic",
            cell: (props: any) => {
                return getBooleanDisplayIcon(props.value, "True", "False");
            },
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Use Integer Arithmetic...", "useIntegerArithmetic", "True", "False"),
            }],
        },
    ]

    // const selector = (state: any) => state.getAllTaxRoundingConfigReducer;

    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>
            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchTaxRoundingConfigQuery,
                }}
                userSettingGroup={"Tax Rounding Config"}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/tax-rounding-config/create")
                            }}
                            title={"Add Tax Rounding Configuration"}
                        />,
                        permissions: ["TAXRCONF-C"]
                    },

                }}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"TAXRCONF"}
            />

        </div>

    );
};

export default TaxRoundingConfig;